export default __webpack_public_path__ + "img/Square_1.2f4bc913f9dc6a1d67ec0cbd274d9805.jpg";